<ng-container *ngIf="customerLanding$ | async; let customerLanding">
    <mat-drawer-container autosize>
        <mat-drawer #drawer position="end" mode="over"
            ><app-guest-mode-login
                *ngIf="accessModeSub | async; let accessMode"
                [accessMode]="accessMode"
                (onLoginOrSignup)="onLoginOrSignup()"
                [customerLanding]="customerLanding"
            ></app-guest-mode-login
        ></mat-drawer>
        <ng-container *ngIf="!(guestMode$ | async)">
            <app-header
                *ngIf="!(isMobile | async)"
                [guest]="true"
                [onboarding]="onboarding"
                [isHeaderWithOnlyLang]="isHeaderWithOnlyLang"
                class="guest-header"
            >
                <app-module-menu>
                    <div class="flex-space"></div>
                </app-module-menu>
            </app-header>

            <app-mobile-header *ngIf="isMobile | async">
                <ng-content select="appMenuTitle"></ng-content>
            </app-mobile-header>
        </ng-container>
        <router-outlet (activate)="componentAdded($event)"></router-outlet>
    </mat-drawer-container>
</ng-container>
